import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-branch-card',
  imports: [],
  templateUrl: './branch-card.component.html',
  styleUrl: './branch-card.component.scss',
})
export class BranchCardComponent {
  @Input() nombre = '';
  @Input() telefono = '';
  @Input() calle = '';
  @Input() numeroInterior = '';
  @Input() referencias = '';
  @Input() cp = '';
}
